import { TokenService } from './token.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GenericAgencyService {
  agencyUrl = environment.agencyUrl;
  userUrl = environment.userUrl;
  utilUrl = environment.utilUrl;

  constructor(
    private http: HttpClient,
    private tokenService: TokenService,
  ) {}

  enSureLoggedin() {
    const idToken = this.tokenService.getIdToken();
    const areTokensExpired = this.tokenService.areTokensExpired();
    const accessToken = this.tokenService.getaccessToken();

    if (idToken && accessToken && !areTokensExpired) return true;
    else {
      this.tokenService.login();
      return false;
    }
  }

  public Get<T>(url: string): Observable<T> {
    if (!this.enSureLoggedin()) return new Observable<any>();

    return this.http.get<T>(this.agencyUrl + url);
  }

  public GetWithFilters<T>(url: string, filters?: HttpParams): Observable<T> {
    if (!this.enSureLoggedin()) return new Observable<any>();

    return this.http.get<T>(this.agencyUrl + url, { params: filters });
  }

  public Post<T>(url: string, data: any): Observable<T> {
    if (!this.enSureLoggedin()) return new Observable<any>();

    return this.http.post<T>(this.agencyUrl + url, data);
  }

  public PostUser<T>(url: string, data: any): Observable<T> {
    if (!this.enSureLoggedin()) return new Observable<any>();

    return this.http.post<T>(this.userUrl + url, data);
  }

  public postWithFilters<T>(
    url: string,
    data: any,
    filters?: HttpParams,
  ): Observable<T> {
    if (!this.enSureLoggedin()) return new Observable<any>();

    return this.http.post<T>(this.agencyUrl + url, data, { params: filters });
  }

  public Put<T>(url: string, data: any): Observable<T> {
    if (!this.enSureLoggedin()) return new Observable<any>();

    return this.http.put<T>(this.agencyUrl + url, data);
  }

  public patch<T>(url: string, data: any): Observable<T> {
    if (!this.enSureLoggedin()) return new Observable<any>();

    return this.http.patch<T>(this.agencyUrl + url, data);
  }

  public Delete<T>(url: string): Observable<T> {
    if (!this.enSureLoggedin()) return new Observable<any>();

    return this.http.delete<T>(this.agencyUrl + url);
  }
}
